export default "__VITE_ASSET__EMitwkn5__"